const Config = {
  layout_type: "",
  sidebar_layout: "",
  sidebar_setting: "on",
  color: "style",
  wallpaper: "1"
};

export default Config;
